// PERF OPTIMIZED: Free World store removed from global init
// FW data is now loaded only on /freeworld route via useFreeWorldInitializer
// AUTH GATED: Module/question loading deferred until after authentication
// LANDING ISOLATED: Public routes do NOT trigger any bootstrap or session validation

import React, { useEffect, useState, Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
// DEPRECATED: Toaster kept only for admin components - do not use for player-facing features
import { Toaster } from '@/components/ui/toaster';
import { useModuleStore } from '@/hooks/useModuleStore';
import { useQuestionStore } from '@/hooks/useQuestionStore';
import { router } from './router';
import { useQuestionPointsIntegration } from '@/hooks/useQuestionPointsIntegration';
import { ErrorBoundary } from '@/components/error/ErrorBoundary';
import { ErrorBanner } from '@/components/error/ErrorBanner';
import { CriticalErrorDialog } from '@/components/error/CriticalErrorDialog';
import { OfflineIndicator } from '@/components/ui/OfflineIndicator';
import { TestModeIndicator } from '@/components/dev/TestModeIndicator';
import { DevRequestPanel } from '@/dev/DevRequestPanel';
import { GlobalBanner } from '@/components/system/GlobalBanner';
import { MaintenanceGuard } from '@/components/system/MaintenanceGuard';
import { Card } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { queryClient } from '@/lib/queryClient';
import { initTestMode } from '@/lib/testMode';
import { log } from '@/lib/log';

const AppLoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <Card className="p-8 text-center">
      <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" aria-hidden="true" />
      <h2 className="text-lg font-semibold mb-2">Käynnistetään…</h2>
      <p className="text-sm text-muted-foreground" role="status" aria-live="polite">
        Odota hetki
      </p>
    </Card>
  </div>
);

function App() {
  // Initialize test mode from URL params (dev only)
  useEffect(() => {
    initTestMode();
  }, []);
  
  // Initialize the question points integration
  useQuestionPointsIntegration();

  // DEV: Log when App mounts
  useEffect(() => {
    if (import.meta.env.DEV) {
      console.log('[App] mounted, route:', window.location.pathname);
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <MaintenanceGuard>
        <ErrorBoundary>
          <GlobalBanner />
          <OfflineIndicator />
          <ErrorBanner />
          <CriticalErrorDialog />
          <TestModeIndicator />
          <DevRequestPanel />
          <Suspense fallback={<AppLoadingFallback />}>
            <RouterProvider router={router} />
            {/* DEPRECATED: Toaster kept only for admin components */}
            <Toaster />
          </Suspense>
        </ErrorBoundary>
      </MaintenanceGuard>
    </QueryClientProvider>
  );
}

export default App;
